import { useEffect, useState } from "react"

import { departmentsOptions } from "../../../../lib/systemData"
import WorkersCompDepartment from "./WorkersCompDepartment"

import classes from './WorkersCompDepartments.module.css'

export default function WorkersCompDepartments({data}) {

    const [departments, setDepartments] = useState(null)
    
    
        useEffect(() => {
            let d = departmentsOptions()
            if (d) {
                setDepartments(d)
            } else {
                setDepartments(null)
            }
        }, [])


    return <div className={classes.container}>  
        <table>
            <thead>
                <tr>
                    <th colSpan={3}>Departments</th>
                </tr>
            </thead>
            <tbody>
                {departments && departments.map(department => (
                    <WorkersCompDepartment key={department.id} itemData={department} workerCompData={data}/>
                ))}
            </tbody>
        </table>
    </div>
}